module.exports = __webpack_public_path__ + "img/CAGameDesignPage.e7969b0b.jpg";